import PropTypes from 'prop-types';
import React, { Component } from 'react';
import classNames from 'classnames';
import { RESIZE_COVER } from '../../services/get-image-url';
import resolveImage from '../../services/resolve-user-image';
import { getWidth } from '../../services/wix-sdk-utils';
import styles from './cover.scss';

const getWindowWidth = () => typeof window !== 'undefined' && window.innerWidth;

const getStyle = (cover, showCover, width, height) => ({
  backgroundImage: showCover && cover ? `url(${resolveImage(cover, RESIZE_COVER, width, height)})` : '',
});

class Cover extends Component {
  constructor(props) {
    super(props);

    this.state = {
      width: props.width || getWindowWidth() || getWidth(),
      height: props.height,
    };
  }

  setCover = node => {
    this.cover = node;
  };

  componentDidMount() {
    this.setState({
      width: this.cover.clientWidth,
      height: this.cover.clientHeight,
    });
  }

  render() {
    const { width, height } = this.state;
    const { className, cover, showCover, children, hasActiveState } = this.props;
    const containerClassName = classNames(styles.cover, className, {
      [styles.hasActiveState]: hasActiveState,
    });
    const style = getStyle(cover, showCover, width, height);

    return (
      <div ref={this.setCover} className={containerClassName} style={style} role="img">
        {children}
      </div>
    );
  }
}

Cover.propTypes = {
  className: PropTypes.string,
  cover: PropTypes.object,
  showCover: PropTypes.bool,
  width: PropTypes.number,
  height: PropTypes.number.isRequired,
  children: PropTypes.node,
  hasActiveState: PropTypes.bool,
};

Cover.defaultProps = {
  showCover: true,
  hasActiveState: true,
};

export default Cover;



// WEBPACK FOOTER //
// ./app/components/cover/cover.js